import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ManagementEntityEventModel } from '@data-layer/models/management';
import { CbpMessageHelper } from '@helpers/cbp-message.helper';

@Component({
  selector: 'es-summary-cbp-log-desktop',
  template: `
    <div class="cbp-log">
      <div class="cbp-log-header">
        <span class="cbp-log-header-text">{{ 'BUTTON.CBP_LOG' | translate }}</span>

        <div class="cbp-log-header-actions">
          <span class="cbp-log-header-actions-item" (click)="close.emit()">
            <i class="fa fa-caret-up"></i>
            <span>{{ 'BUTTON.CLOSE' | translate }}</span>
          </span>
        </div>
      </div>
      <div class="cbp-log-body">
        <ng-template [ngIf]="sortedMessages && sortedMessages.length" [ngIfElse]="emptyList">
          <div class="message" [ngClass]="{ expired: expired(message) }" *ngFor="let message of sortedMessages">
            <div class="message-time">
              {{ message.timestamp | date : formatDateTime }}
            </div>
            <div class="message-body">
              {{ message.message }}
            </div>
          </div>
        </ng-template>

        <ng-template #emptyList>
          <div>
            {{ 'NO_MESSAGES_FROM_CBP' | translate }}
          </div>
        </ng-template>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./es-summary-cbp-log-desktop.component.scss'],
})
export class EsSummaryCbpLogDesktopComponent implements OnInit, OnChanges {
  @Input() public messageList: ManagementEntityEventModel[] = [];
  @Input() public sendToProviderDate: string;
  @Output() public close: EventEmitter<void> = new EventEmitter<void>();

  public readonly formatDateTime = 'MM/dd/yyyy HH:mm:ss';

  public sortedMessages: ManagementEntityEventModel[] = [];

  constructor() {}

  public ngOnInit(): void {
    this.sortedMessages = CbpMessageHelper.sortMessages(this.messageList);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.messageList) {
      this.sortedMessages = CbpMessageHelper.sortMessages(this.messageList);
    }
  }

  public expired(message: ManagementEntityEventModel): boolean {
    return CbpMessageHelper.expired(message.timestamp, this.sendToProviderDate);
  }
}
